var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtfoliosolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.426 28.41L48.75 25.03L30.3075 21.887L35.3485 14.5925L28.2915 19.6335L24.97 1.25L21.827 19.7515L14.592 14.5925L19.574 21.8865L1.25 25.03L19.5745 28.41L14.5925 35.408L21.8275 30.426L24.9705 48.75L28.3505 30.545L35.3485 35.4075L30.426 28.41Z",
    fill: "#070908"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtfoliosolution);
export default __webpack_public_path__ + "static/media/protfoliosolution.64014c6259c3edeef94856fd7567c731.svg";
export { ForwardRef as ReactComponent };